export const MAX_BOOKED_WORKERS = 2147483647;

export const isBookedWorkersValid = (value) => (
    Number.isInteger(value) && value >= 0 && value <= MAX_BOOKED_WORKERS
);

export const getBookingDifference = (bookedWorkers, registeredWorkers) => (
    isBookedWorkersValid(bookedWorkers) && isBookedWorkersValid(registeredWorkers) ?
        registeredWorkers - bookedWorkers : null
);

export const canManageEventBookings = (me) => (
    Array.isArray(me?.role?.permissions) && me.role.permissions.some((permission) => (
        permission?.panel === "crm" &&
        permission?.type === "exhibition_event" &&
        permission?.value === null
    ))
);

export const bookingError = (code, message = code) => Object.assign(new Error(message), { code });

export const normalizeBookingError = (error) => {
    const details = error?.graphQLErrors || error?.errors;
    const message = Array.isArray(details) && details.length ? details.map((item) => (
        typeof item?.extensions?.reason === "string" ? item.extensions.reason : item?.message
    )).filter(Boolean).join("; ") : error?.message;
    return bookingError(error?.code || "API_ERROR", message || "API_ERROR");
};

const hasID = (value) => (typeof value === "string" || typeof value === "number") &&
    String(value).trim() !== "";

export const assertBookingResult = (result) => {
    if (result?.error) throw normalizeBookingError(result.error);
    if (result?.errors?.length)
    {
        throw normalizeBookingError(result);
    }
};

export const readEventBookings = (result, eventID) => {
    assertBookingResult(result);
    const rows = result?.data?.eeSubcontractors;
    if (!Array.isArray(rows)) throw bookingError("INVALID_RESPONSE");
    const ids = new Set();
    const companies = new Set();
    for (const row of rows)
    {
        if (!hasID(row?.id) || !hasID(row?.subcontractor_id) ||
            String(row?.ee_id) !== String(eventID) ||
            (row.relSubcontractor && String(row.relSubcontractor.id) !== String(row.subcontractor_id)) ||
            ids.has(String(row.id)) || companies.has(String(row.subcontractor_id)))
        {
            throw bookingError("INVALID_RESPONSE");
        }
        ids.add(String(row.id));
        companies.add(String(row.subcontractor_id));
    }
    return rows;
};
